export interface CustomerDiscountTextProps {
  isVariant: boolean;
  isContractPrice: boolean;
  isHeaderDiscounted: boolean;
  styleModifier: string | undefined;
}

export function CustomerDiscountText({
  isVariant,
  isContractPrice,
  isHeaderDiscounted,
  styleModifier
}: CustomerDiscountTextProps) {
  const renderDiscountText = () => {
    if (!isVariant) {
      if (isContractPrice) {
        return (
          <div
            className={`contract-list-item contract-list-item${styleModifier}`}
          >
            Your contract price
          </div>
        );
      } else if (isHeaderDiscounted) {
        return (
          <div
            className={`contract-list-item contract-list-item${styleModifier}`}
          >
            Your discount price
          </div>
        );
      }
    }
  };
  return <>{renderDiscountText()}</>;
}
